<div class="ccm_usage">
    <div class="spinner-content" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="ccm_usage_left full_width">
        <h4 *ngIf="!loading">Autoimmune
            Diseases</h4>
        <p [innerHTML]="dataInsight?.ad_text | safeHtml" *ngIf="!loading"></p>
        <div class="ccm_usage_ryt autoimmune_ryt">
            <div class="canvas">
                <canvas id="autoImmunebarChart" height="200" width="250"></canvas>
            </div>
        </div>
        <ul *ngIf="!loading">
            <li>Participants reported having additional autoimmune diseases </li>
            <li>Participants reported not having additional autoimmune diseases</li>
        </ul>
    </div>

</div>